<div class="template-container" *ngIf="template">
	<!-- Form fields at the top spanning full width -->
	<div class="template-header">
		<div class="field">
			<label for="template-name">Template Name</label>
			<input pInputText type="text" id="template-name" [(ngModel)]="template.templateName" (ngModelChange)="isDirty = true" />
			<p *ngIf="errors.templateName" class="error">{{ errors.templateName }}</p>
		</div>
		<div class="field">
			<label for="template">Select Template to base this one on.</label>
			<p-dropdown [options]="templates" [optionLabel]="'templateName'" id="template" [(ngModel)]="selectedTemplate" (onChange)="selectTemplate()" />
		</div>
	</div>

	<!-- Editor and substitution fields side by side -->
	<div class="template-content">
		<div class="substitution-sidebar">
			<app-substitution-fields [showVimeoOption]="true"></app-substitution-fields>
		</div>

		<div class="template-main">
			<p *ngIf="errors.templateHtml" class="error">{{ errors.templateHtml }}</p>
			<email-editor (loaded)="editorLoaded($event)" [options]="editorOptions" [minHeight]="'1000px'"></email-editor>
		</div>
	</div>
</div>
